import { LanguageSetter } from "../i18n/LanguageContext";
import ServicesPage from "./Services";
import DocumentMeta from "react-document-meta";
import { buildPageMeta } from "../seo";

const ServiziPage = () => {
    const meta = buildPageMeta({
        title: "Servizi | Maurizio Brioschi",
        description: "Pagina servizi in italiano: consulenza, architettura software, sviluppo web e trasformazione digitale.",
        keywords: "servizi sviluppo web, architettura software, consulenza digitale",
        path: "/servizi"
    });
    return (
        <>
            <DocumentMeta {...meta} />
            <LanguageSetter language="it">
                <ServicesPage />
            </LanguageSetter>
        </>
    );
};

export default ServiziPage;
